"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewType = void 0;
var ViewType;
(function (ViewType) {
    ViewType["PROFILE"] = "profile";
    ViewType["JOURNEY"] = "journey";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
